VjsAdmin.UserSearch = (function () {
    const $vjsTable = $('#vjs-results-table');
    const $jrTable = $('#jr-results-table');
    const $cpTable = $('#cp-results-table');

    let platformsQueried = 0;

    const buttonDefault = 'Search Users';
    const buttonActive = 'Searching... <i class="fa fa-spinner fa-spin fa-fw"></i>';
    const buttonComplete = 'Search Again';

    const reportsTableOptions = {
        ...VjsTable.tableDefaults(),
        showColumns: true,
        idField: 'last_name',
        search: false,
        sortName: 'last_name',
        toolbarAlign: 'left',
        url: Slim.Router.pathFor('user_search.json'),
        formatNoMatches() {
            return `No matching users found on ${this.platform_name}!`;
        },
        onLoadSuccess(data) {
            VjsTable.tableDefaults().onLoadSuccess.call(this, data);
            $(this.results_container_element).find('.alert').remove();
            $('#result-list-container').fadeIn();
            $(this.results_container_element).find('.results-container').fadeIn();
            platformsQueried--;
            if (platformsQueried <= 0) {
                $('#run-report').prop('disabled', false).html(buttonComplete);
                $('#ajax-progress-indicator').fadeOut();
            }
        },
        updateUrl() {
            const queryParams = {};

            if ($('#search-first-name').val()) {
                queryParams.search_first_name = $('#search-first-name').val();
            }
            if ($('#search-last-name').val()) {
                queryParams.search_last_name = $('#search-last-name').val();
            }
            if ($('#search-username').val()) {
                queryParams.search_username = $('#search-username').val();
            }
            if ($('#search-unique-identifier').val()) {
                queryParams.search_unique_identifier = $('#search-unique-identifier').val();
            }
            if ($('#search-user-role').val() && $('#search-user-role').val() !== 'all') {
                queryParams.search_user_role = $('#search-user-role').val();
            }
            if ($('#search-active').val() && $('#search-active').val() !== '1') {
                queryParams.search_active = $('#search-active').val();
            }
            VjsTable.tableDefaults().updateUrl.call(this, queryParams);
        },
        onLoadError(status) {
            if (+status === 500 || +status === 404) {
                // eslint-disable-next-line no-new, new-cap
                new PNotify.error({
                    title: 'Load Error',
                    text: `${this.platform_name} cannot be reached!`,
                    icon: 'fa fa-exclamation-triangle',
                    type: 'error',
                });
            }
            $(this.results_count_element).html('(<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>)');
            $(this.results_container_element).find('.results-container').fadeOut();
            $(this.results_container_element).find('.alert').remove();
            $(this.results_container_element).prepend(
                `<div class="alert alert-danger" role="alert"><div class="wrapper"><div class="icon"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div> <!-- /.icon --><div class="message">An error occurred while retrieving users from ${this.platform_name}!</div> <!-- /.message --></div> <!-- /.wrapper --></div> <!-- /.alert -->`,
            );
            platformsQueried--;
            if (platformsQueried <= 0) {
                $('#run-report').prop('disabled', false).html(buttonComplete);
                $('#ajax-progress-indicator').fadeOut();
            }
        },
        queryParams(params) {
            const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
            myParams.platform_id = this.platform_id;
            myParams.first_name = $('#search-first-name').val().trim();
            myParams.last_name = $('#search-last-name').val().trim();
            myParams.username = $('#search-username').val().trim();
            myParams.unique_identifier = $('#search-unique-identifier').val().trim();
            switch ($('#search-user-role option:selected').val()) {
                case 'all':
                    break;
                case 'admin':
                    myParams.admins_only = 1;
                    break;
                case 'user':
                    myParams.users_only = 1;
                    break;
                default:
                    break;
            }
            if ($('#search-active option:selected').val() !== 'all') {
                myParams.active = $('#search-active option:selected').val();
            }
            return myParams;
        },
        responseHandler(res) {
            const formattedResult = {};
            formattedResult.total = res.meta.total;
            formattedResult.rows = res.data;
            $(this.results_count_element).html(`(${formattedResult.total})`);

            const platformId = this.platform_id;

            $(formattedResult.rows).each((i, result) => {
                // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                const dateFormat = 'MM/DD/YYYY';
                const timeagoArray = [];
                const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                row.is_active = row.active;

                if (+row.active === 0) {
                    row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                } else {
                    row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                }

                if (+row.has_logged_in === 0 || row.date_last_login == null) {
                    row.has_logged_in = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                } else {
                    row.has_logged_in = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                }

                if (VjsAdmin.hasPermission('platforms.districts.licenses.users.view')) {
                    const userUrl = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                        license_id: row.license_id,
                        user_id: row.user_id,
                    });
                    row.username = `<a href="${userUrl}" class="">${row.username}</a>`;
                    row.first_name = `<a href="${userUrl}" class="">${row.first_name}</a>`;
                    row.last_name = `<a href="${userUrl}" class="">${row.last_name}</a>`;
                }

                if (VjsAdmin.hasPermission('platforms.districts.view')) {
                    const districtUrl = Slim.Router.pathFor('platforms.districts.view', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                    });
                    row.district_name = `<a href="${districtUrl}" class="">${row.district_name}</a>`;
                }

                if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                    const licenseUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                        license_id: row.license_id,
                    });
                    row.license_name = `<a href="${licenseUrl}" class="">${row.license_name}</a>`;
                }
            });

            return formattedResult;
        },
        columns: [
            {
                title: 'Username',
                field: 'username',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'First Name',
                field: 'first_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Last Name',
                field: 'last_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Unique ID',
                field: 'unique_identifier',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Email',
                field: 'email',
                align: 'left',
                valign: 'middle',
                sortable: false,
                visible: false,
            },
            {
                title: 'Rostering Type',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Rostering ID',
                field: 'rostering_id',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Role',
                field: 'role',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Grade',
                field: 'grade',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'Grad Year',
                field: 'graduation_year',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                field: 'date_last_activity',
                align: 'left',
                valign: 'middle',
                sortable: true,
                sorter: VjsAdmin.dateSorter,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Login',
                field: 'date_last_login',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                sorter: VjsAdmin.dateSorter,
            },
            {
                title: 'Has Logged In',
                field: 'has_logged_in',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
        ],
    };

    const init = function () {
        $('#search-first-name').val($.urlParam('search_first_name') ? decodeURIComponent($.urlParam('search_first_name')) : null);
        $('#search-last-name').val($.urlParam('search_last_name') ? decodeURIComponent($.urlParam('search_last_name')) : null);
        $('#search-username').val($.urlParam('search_username') ? decodeURIComponent($.urlParam('search_username')) : null);
        $('#search-unique_identifier').val(
            $.urlParam('search_unique_identifier') ? decodeURIComponent($.urlParam('search_unique_identifier')) : null,
        );
        $(
            `#search-user-role option[value=${$.urlParam('search_user_role') ? decodeURIComponent($.urlParam('search_user_role')) : null}]`,
        ).attr('selected', true);
        $(`#search-active option[value=${$.urlParam('search_active') ? decodeURIComponent($.urlParam('search_active')) : null}]`).attr(
            'selected',
            true,
        );

        $('#report-form').on('change', 'input, select', () => {
            $('#run-report').prop('disabled', false).html(buttonDefault);
        });

        $('#report-form').on('submit', (event) => {
            event.preventDefault();
            $('#ajax-progress-indicator').fadeIn();

            $('#run-report').prop('disabled', true).html(buttonActive);
            $('#vjs_num_results').html('(<i class="fa fa-spinner fa-spin fa-fw"></i>)');
            $('#jr_num_results').html('(<i class="fa fa-spinner fa-spin fa-fw"></i>)');

            // get vjs license data
            const vjsTableOptions = {
                ...reportsTableOptions,
                table: '#vjs-results-table',
                platform_id: 1,
                platform_name: 'VirtualJobShadow.com',
                results_count_element: '#vjs_num_results',
                results_container_element: '#vjs-results',
                toolbar: '#vjs-report-toolbar',
            };
            $vjsTable.bootstrapTable('destroy');
            platformsQueried++;
            $vjsTable.bootstrapTable(vjsTableOptions);

            // get jr license data
            const jrTableOptions = {
                ...reportsTableOptions,
                table: '#jr-results-table',
                platform_id: 2,
                platform_name: 'VJSJunior.com',
                results_count_element: '#jr_num_results',
                results_container_element: '#jr-results',
                toolbar: '#jr-report-toolbar',
            };

            $jrTable.bootstrapTable('destroy');
            platformsQueried++;
            $jrTable.bootstrapTable(jrTableOptions);

            // get cp license data
            const cpTableOptions = {
                ...reportsTableOptions,
                table: '#cp-results-table',
                platform_id: 4,
                platform_name: 'Course Planner',
                results_count_element: '#cp_num_results',
                results_container_element: '#cp-results',
                toolbar: '#cp-report-toolbar',
            };

            $cpTable.bootstrapTable('destroy');
            platformsQueried++;
            $cpTable.bootstrapTable(cpTableOptions);

            reportsTableOptions.updateUrl();
            return false;
        });

        $('.app-content').on('click', '#vjs-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $vjsTable.bootstrapTable('getOptions').queryParams.call($vjsTable.bootstrapTable('getOptions'));
            const visibleColumns = $vjsTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            if ($('#include-usage-stats').prop('checked')) {
                exportColumns.usage_date_range = 'Usage Date Range';
            }
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        $('.app-content').on('click', '#jr-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $jrTable.bootstrapTable('getOptions').queryParams.call($jrTable.bootstrapTable('getOptions'));
            const visibleColumns = $jrTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        $('.app-content').on('click', '#cp-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $cpTable.bootstrapTable('getOptions').queryParams.call($cpTable.bootstrapTable('getOptions'));
            const visibleColumns = $cpTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        if (
            $.urlParam('search_first_name')
            || $.urlParam('search_last_name')
            || $.urlParam('search_username')
            || $.urlParam('search_unique_identifier')
            || $.urlParam('search_user_roles')
            || $.urlParam('search_active')
        ) {
            $('#report-form').trigger('submit');
        }
    };

    return {
        init,
    };
}());
